var ERROR_PATH = "/error";
var RESOURCE_NOT_FOUND = "/resourceNotFound";

angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when(ERROR_PATH, {
        templateUrl: 'assets/error/index.html',
        controller: 'ErrorController'
    }).when(RESOURCE_NOT_FOUND, {
        templateUrl: 'assets/error/notFound.html',
        controller: 'ErrorController'
    });
}]);




//////////////////
// WEBPACK FOOTER
// ./public/app/routes/error_route.js
// module id = 812
// module chunks = 3